import { createStore } from 'vuex'

import iam from './modules/iam'
import notifications from './modules/notifications';
import sidebar from './modules/sidebar'
import splash from './modules/splash'

const store = createStore();

store.registerModule('iam', iam);
store.registerModule('sidebar', sidebar);
store.registerModule('splash', splash);
store.registerModule('notifications', notifications);

export default store;